module.exports = __webpack_public_path__ + "templates/product-amount-directive.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/plugins/products/templates/product-amount-directive.html
// module id = jdUm
// module chunks = 1